/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateGenerationRequest } from '../models/CreateGenerationRequest';
import type { CreateGenerationResponse } from '../models/CreateGenerationResponse';
import type { Generation } from '../models/Generation';
import type { GenerationListResponse } from '../models/GenerationListResponse';
import type { GenerationStatus } from '../models/GenerationStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GenerationsService {
    /**
     * List current account generations
     * @returns GenerationListResponse Current account generation page
     * @throws ApiError
     */
    public static getApiV1Generations({
        status,
        search,
        limit = 20,
        cursor,
    }: {
        status?: GenerationStatus,
        search?: string,
        limit?: number,
        cursor?: string,
    }): CancelablePromise<GenerationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/generations',
            query: {
                'status': status,
                'search': search,
                'limit': limit,
                'cursor': cursor,
            },
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Create new generation from one photo
     * @returns CreateGenerationResponse Generation accepted
     * @throws ApiError
     */
    public static postApiV1Generations({
        formData,
    }: {
        formData: CreateGenerationRequest,
    }): CancelablePromise<CreateGenerationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/generations',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Invalid input or media`,
                401: `Unauthenticated`,
                404: `Catalog item not found`,
                422: `Insufficient balance or invalid item state`,
            },
        });
    }
    /**
     * Get current account generation detail
     * @returns Generation Generation detail
     * @throws ApiError
     */
    public static getApiV1Generations1({
        generationId,
    }: {
        generationId: string,
    }): CancelablePromise<Generation> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/generations/{generationId}',
            path: {
                'generationId': generationId,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Generation not found`,
            },
        });
    }
    /**
     * Download current account generation result video
     * @returns binary Result video file
     * @throws ApiError
     */
    public static getApiV1GenerationsResultVideo({
        generationId,
    }: {
        generationId: string,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/generations/{generationId}/result-video',
            path: {
                'generationId': generationId,
            },
            errors: {
                400: `Invalid generation id or account context`,
                401: `Unauthenticated`,
                404: `Generation not found or result not ready`,
                500: `Result media unavailable`,
                502: `Failed to fetch result video`,
            },
        });
    }
    /**
     * Download current account generation source image
     * @returns binary Source image file
     * @throws ApiError
     */
    public static getApiV1GenerationsSourceImage({
        generationId,
    }: {
        generationId: string,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/generations/{generationId}/source-image',
            path: {
                'generationId': generationId,
            },
            errors: {
                400: `Invalid generation id or account context`,
                401: `Unauthenticated`,
                404: `Generation not found or source image unavailable`,
                500: `Source media unavailable`,
                502: `Failed to fetch source image`,
            },
        });
    }
    /**
     * Download current account generation second source image
     * @returns binary Second source image file
     * @throws ApiError
     */
    public static getApiV1GenerationsSourceImage2({
        generationId,
    }: {
        generationId: string,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/generations/{generationId}/source-image-2',
            path: {
                'generationId': generationId,
            },
            errors: {
                400: `Invalid generation id or account context`,
                401: `Unauthenticated`,
                404: `Generation not found or second source image unavailable`,
                500: `Source media unavailable`,
                502: `Failed to fetch second source image`,
            },
        });
    }
    /**
     * Stream generation updates for current account
     * @returns string SSE stream of generation updates
     * @throws ApiError
     */
    public static getApiV1GenerationsEvents(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/generations/events',
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
}
